import React from 'react'
import TrophyCell from "./TrophyCell";
import BadgeCell from "./BadgeCell";
import { BADGE_TYPE } from '../../../../services/badging/constants'

const columns = [
  {
    label: 'Last Name',
    render: x => x.lastName,
  },
  {
    label: 'First Name',
    render: x => x.firstName,
  },
  {
    label: 'Badges Earned',
    render: x => <TrophyCell value={x.earnedCount} />,
    cellClassName: 'badgingTableAwardCell',
  },
  {
    label: 'New Awards',
    render: x => {
      let newAwardCount = 0;
      for (const badgeTypeId of x.studentCellSelection) {
        const badges = x.badges[badgeTypeId] || [];
        for (const badge of badges) {
          if (!badge.awarded) newAwardCount++;
        }
      }
      return <TrophyCell isNew value={newAwardCount} />
    },
    cellClassName: 'badgingTableAwardCell',
  },
  {
    label: 'Total Sessions',
    badgeTypeId: BADGE_TYPE.NUM_SESSIONS,
    render: x => {
      const type = BADGE_TYPE.NUM_SESSIONS;
      return <BadgeCell 
        badges={x.badges[type]} 
        selected={x.studentCellSelection.includes(type)}
        onClick={() => x.toggleCell(x.studentId, type)}
      />
    }
  },
  {
    label: 'Minutes This Week',
    badgeTypeId: BADGE_TYPE.NUM_MINUTES,
    render: x => {
      const type = BADGE_TYPE.NUM_MINUTES;
      return <BadgeCell 
        badges={x.badges[type]} 
        selected={x.studentCellSelection.includes(type)}
        onClick={() => x.toggleCell(x.studentId, type)}
      />
    }
  },
  {
    label: 'WCPM',
    badgeTypeId: BADGE_TYPE.NEW_WCPM_HIGH,
    render: x => {
      const type = BADGE_TYPE.NEW_WCPM_HIGH;
      return <BadgeCell 
        badges={x.badges[type]} 
        selected={x.studentCellSelection.includes(type)}
        onClick={() => x.toggleCell(x.studentId, type)}
      />
    }
  },
  {
    label: 'Skills Scaffold Graduation',
    badgeTypeId: BADGE_TYPE.SKILLS_SCAFFOLD_GRADUATION,
    render: x => {
      const type = BADGE_TYPE.SKILLS_SCAFFOLD_GRADUATION;
      return <BadgeCell 
        badges={x.badges[type]} 
        selected={x.studentCellSelection.includes(type)}
        onClick={() => x.toggleCell(x.studentId, type)}
      />
    }  
  },
  {
    label: 'New High',
    badgeTypeId: BADGE_TYPE.NEW_HIGH,
    render: x => {
      const type = BADGE_TYPE.NEW_HIGH;
      return <BadgeCell 
        badges={x.badges[type]} 
        selected={x.studentCellSelection.includes(type)}
        onClick={() => x.toggleCell(x.studentId, type)}
      />
    }  
  },
  {
    label: 'Built By You',
    badgeTypeId: BADGE_TYPE.CUSTOM,
    render: x => {
      const type = BADGE_TYPE.CUSTOM;
      return <BadgeCell 
        badges={x.badges[type]} 
        selected={x.studentCellSelection.includes(type)}
        onClick={() => x.toggleCell(x.studentId, type)}
        sort="byDate"
      />
    },
    cellClassName: 'badgingTableCustomCell'
  }
]

export default columns;